/**
 * 後台管理員登入（不掛 LIFF SDK）
 * email + password → POST /api/auth/admin-login → JWT 存 authStore
 */
import { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "../../api/admin";
import { useAuthStore } from "../../store/authStore";
import { useUIStore } from "../../store/uiStore";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await adminLogin(email, password);
      useAuthStore.getState().setAdminJwt(r.jwt, r.email);
      navigate("/admin", { replace: true });
    } catch (e: any) {
      useUIStore.getState().showToast(e?.response?.data?.error || "登入失敗", "error");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-5">
      <form onSubmit={submit} className="card w-full max-w-sm space-y-4">
        <div>
          <div className="text-xs text-muted">霽雲 · 管理後台</div>
          <h1 className="text-xl font-bold mt-1">管理員登入</h1>
        </div>
        <div>
          <label className="label">Email</label>
          <input
            className="input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="label">密碼</label>
          <input
            className="input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" disabled={busy} className="btn-primary w-full">
          {busy ? "登入中…" : "登入"}
        </button>
      </form>
    </div>
  );
}
